import AxiosInstance from "./api";

export const BusinessCodeService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/business-code", {
      params: query,
    });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/business-code/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/business-code", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/business-code/" + id, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete("/private/business-code/" + id);
  },
};
